export default {
  props: {
    copy_action: null,
    terms: {},
    wizard_attrs: {
      steps: [],
      finalStepLabel: '',
      showCancelBtn: {},
    },
  },

  data: {
    export_type: 'kannu_export',
    originCourse: {},
    course: {
      id: null,
      name: '',
      number: '',
      term_id: null,
      instructors: [],
      instructor_id: null,
      institution_id: null,
    },
    courses: {
      key: '',
      display_name: '',
      institution_id: {},
      term_id: {},
      name: '',
      number: '',
    },
    course_attrs: {
      key: '',
      clone_only: false,
      shown: false,
      display_name: '',
      checked: true
    },
    lectures: {
      key: 0,
      checked: false,
      display_name: '',
    },
    coursework: {
      key: 0,
      checked: false,
      display_name: '',
    },
    resources: {
      key: 0,
      checked: false,
      display_name: '',
    },
    coursework_attrs: {},
    copy_terms: {},
    selected_term: null,
    selected_institution: null,
    selected_course: null,
    filtered_courses: [],
    // features
    toggle: {
      course: true,
      lectures: true,
      coursework: true,
      resources: true,
    },
    expand: {
      course: false,
      lectures: false,
      coursework: false,
      resources: false,
    },
    review: {
      course: false,
      lectures: false,
      coursework: false,
      resources: false,
    },
    // archival backup
    forums_enabled: false,
    attribs: {
      sessions: true,
      coursework: true,
      resources: true,
      announcements: true,
      coursework_submissions: true,
      forums: true,
      course_media: true,
      session_media: true,
      coursework_media: true,
      resource_media: true,
    },
  },

  watch: {
    selected_course(val, oldVal) {
      this.getCourseInfo(val);
    },

    selected_institution(val, oldVal) {
      this.filterCourses('institution');
    },
  },

  computed: {
    isKannuExport() {
      return this.export_type === 'kannu_export'
    },

    isArchivalExport() {
      return this.export_type === 'archival_export'
    },

    isCommonCartridge() {
      return this.export_type === 'common_cartridge'
    },
  },

  methods: {
    bindData(courseContent) {
      _.extendOwn(this, courseContent);

      if(this.courses.length)
        this.filtered_courses = this.courses;
    },

    filterCourses(filterType) {
      this.$nextTick(() => {
        const selectedFilterId = this[`selected_${filterType}`]

        if (!selectedFilterId) {
          this.filtered_courses = this.courses
        } else {
          this.filtered_courses = this.courses.filter(
            course => course[`${filterType}_id`] === parseInt(selectedFilterId)
          )
        }
      });
    },

    getCourseInfo(courseId) {
      if(_.isEmpty(courseId))
        return false;

      const data = `course[id]=${courseId}`;

      const request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.course_create_actions_clone_path(),
        dataAsJSON: false,
        data: data
      });

      request.fail((xhr, textstatus, message) => {
        new Kadenze.Notice.error(xhr.responseJSON);
      });

      request.done((data, textStatus, xhr) => {
        _.extendOwn(this, _.omit(data, 'course'));

        _.each(['name', 'number', 'institution_id', 'id', 'instructors'], prop => {
          this.course[prop] = data.course[prop];
          this.originCourse = data.course;
        });

        this.selected_institution = data.course.institution_id;
      });
    },

    // feature selection methods
    reviewExpand(event) {
      const btnClasses = event.target.classList;
      const ulClasses = event.target.nextElementSibling.classList;

      ulClasses.contains('is-hidden') ? ulClasses.remove('is-hidden') : ulClasses.add('is-hidden');
      btnClasses.contains('isExpanded') ? btnClasses.remove('isExpanded') : btnClasses.add('isExpanded');
    },

    getAttrs(type) {
      if(type == 'course') {
        return this.course_attrs;
      } else if (type == 'lecture') {
        return this.lectures;
      } else if (type == 'coursework') {
        return this.coursework;
      } else if (type == 'resources') {
        return this.resources;
      }
    },

    toggleChecked(current_attrs, type){
      const attrs = this.getAttrs(type);
      const attr = attrs.filter(a => a.key === current_attrs.key).shift()
      attr.checked = !attr.checked
    },

    toggleSwitch(val, event) {
      const switchVal = val;
      const attrs = this.getAttrs(event.target.value);
      attrs.map(obj => obj.checked = switchVal);
    },

    cloneCourse() {
      this.submitCourse({
        export: false,
        message: 'Course submitted for copying'
      })
    },

    moveCourse() {
      this.submitCourse({
        move: true,
        message: 'Course submitted for institutions moving'
      })
    },

    submitCourse(item) {
      this.selected_vals = {};
      this.selected_vals.course = {};
      this.selected_vals.course.copy_from = this.selected_course;

      _.extendOwn(this.selected_vals.course, this.course);

      this.selected_vals.course.course_attrs = {};
      if(item.export) {
        this.selected_vals.course.export = true;
        this.selected_vals.course.copy_from = this.course.id;
      } else if (item.move) {
        this.selected_vals.course.move = true;
        this.selected_vals.course.copy_from = this.course.id;
      } else {
        this.selected_vals.course.id = null;
      }

      this.selected_vals.course.course_attrs.course = _.where(
        this.course_attrs,
        { checked: true }
      );

      _.each(['lectures','coursework','resources'], model => {
        this.selected_vals.course.course_attrs[model] = [];

        _.each(this[model], obj => {
          if (obj.checked)
            this.selected_vals.course.course_attrs[model].push(obj);
        });
      });

      let url;
      if(this.selected_vals.course.move) {
        url = Kadenze.Routes.course_create_actions_move_path()
      } else if (!isNaN(parseInt(this.selected_vals.course.copy_from)) || this.isKannuExport) {
        url = Kadenze.Routes.cloner_courses_path();
      } else {
        url = Kadenze.Routes.courses_path();
      }

      const request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: url,
        dataAsJSON: true,
        data: this.selected_vals,
        loadingIndicator: {
          container: $('#main'), // jQuery Object, holder for the loader
          cb: () => {}, // Callback that is called after the loader fades in
          positionTop: 'fixed', // String, 'fixed' covers the whole page, 'top' is relative to the container
          message: 'Submitting...' // String, message to display under the loader graphic
        }
      });

      request.fail((xhr, textstatus, message) => {
        if (textstatus === 'timeout') {
          new Kadenze.Notice.error({ message: I18n.t('notice.unexpected_error') });
        } else {
          new Kadenze.Notice.error(xhr.responseJSON);
        }
      });

      request.done(data => {
        new Kadenze.Notice.success({ message: data.notice });
        this.$children[0].$refs.complete.disabled = true;
        window.location.href = data.redirectTo;
      });
    },

    // export functionality
    getExportType() {
      return $('input[name=\'export-radio-group\']:checked').val();
    },

    exportComplete() {
      if (this.isKannuExport) {
        this.exportCourse();
      } else if (this.isArchivalExport) {
        this.exportBackup();
      } else if (this.isCommonCartridge) {
        this.exportCommonCartridge();
      }
    },

    exportCourse() {
      const msg = 'This will generate an export file for the course. You will receive a notification when it is complete.';

      Kadenze.UIUtil.confirmAction(msg, () => this.submitCourse({ export: true }))
    },

    exportBackup() {
      const request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.course_archives_create_path(this.course.id),
        data: { 'course_archive': this.attribs },
        dataAsJson: false,
        loadingIndicator: {
          container: $('#main'),
          cb: () => {},
          positionTop: 'fixed',
          message: 'Submitting...'
        }
      });

      request.done(data => {
        this.$children[0].$refs.complete.disabled = true;
        new Kadenze.Notice.success(
          {
            message: 'Course download file is being generated. You will receive a notification once it is available.'
          }
        );
        window.location.replace(Kadenze.Routes.course_path(this.course.id));
      });

      request.fail((xhr, textStatus, errorThrown) => {
        new Kadenze.Notice.error({ message: I18n.t('notice.unexpected_error') });
      });
    },

    exportCommonCartridge() {
      const request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.course_archives_create_path(this.course.id),
        data: { 'course_archive': { 'common_cartridge': true } },
        dataAsJson: false,
        loadingIndicator: {
          container: $('#main'),
          cb: () => {},
          positionTop: 'fixed',
          message: 'Submitting...'
        }
      });

      request.fail((xhr, textStatus, errorThrown) => {
        new Kadenze.Notice.error({
          message: I18n.t('notice.unexpected_error')
        })
      });

      request.done(data => {
        this.$children[0].$refs.complete.disabled = true;

        new Kadenze.Notice.success({
          message: 'Common Cartridge file is being generated. You will receive a notification once it is available.'
        });

        window.location.replace(Kadenze.Routes.course_path(this.course.id));
      });
    },

    validateCourse(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createCourse();
        } else {
          this.validationError(e);
        }
      }).catch(e => {
        this.validationError(e);
      });
    },

    validationError(e) {
      if (this.errors.all().length) {
        new Kadenze.Notice.error({
          title: 'Please fix the following validation errors',
          persistent: true,
          message: this.errors.all(),
        });
      }
    },

    createCourse() {
      Kadenze.Ajax.post({
        routeName: 'courses',
        data: this.course,

        loadingIndicator: {
          container: $('#main'),
          positionTop: 'fixed',
          message: 'Submitting...'
        },

        fail (xhr, textStatus, message) {
          if (textStatus === 'timeout') {
            new Kadenze.Notice.error({ message: I18n.t('notice.unexpected_error') });
          } else if(xhr.statusText === 'Unprocessable Entity') {
            new Kadenze.Notice.error({ message: xhr.responseJSON.errors[0] });
          } else {
            new Kadenze.Notice.error(xhr.responseJSON);
          }
        },

        done (data) {
          document.getElementById('create-course-submit').disabled = true;
          window.location.replace(Kadenze.Routes.course_path(JSON.parse(data.course).id));
        },
      })
    },
  },

  beforeMount() {
    if(this.isArchivalExport) {
      const settings = this.course.settings || {};
      const features = settings.features || { disabled: [] };
      const disabled = features.disabled || [];
      this.forums_enabled = !disabled.includes('forums');
    }
  },
};
